import type { ReactNode } from "react";
import { Capacitor } from "@capacitor/core";
import { Link } from "react-router-dom";

/** Native companion apps use existing entitlements; purchases remain web-only. */
export function WebBillingOnly({ children }: { children: ReactNode }) {
  if (!Capacitor.isNativePlatform()) return <>{children}</>;
  return (
    <section className="mx-auto max-w-lg px-6 py-12 space-y-4">
      <h1 className="font-display text-2xl">Your account</h1>
      <p>Your existing account features are available in the app. Plan changes aren't available here.</p>
      <Link className="text-primary underline" to="/pro/home">Back to your dashboard</Link>
    </section>
  );
}
